module.exports = __webpack_public_path__ + "static/media/ProfessionalBrand.e5092083.svg";